import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Row, Modal, Col } from 'react-bootstrap';

import RadioButton from '../../../components/RadioButton/RadioButton';
import * as BECaller from '../../../util/apiCaller';
import { error, savePaymentInfo } from '../BillingActions';

import Close from '../../../assets/img/close.svg';
import saveIcon from '../../../assets/img/save.svg';

// Import Style
import '../Billing.scss';

const BraintreeClient = require('braintree-web/client');
const BraintreeHostedFields = require('braintree-web/hosted-fields');
const BraintreePaypal = require('braintree-web/paypal-checkout');

class PaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      type: 'card'
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    BECaller.api(`billing/getToken`, 'get').then(res => {
      BraintreeClient.create(
        {
          authorization: res.token
        },
        (err, clientInstance) => {
          if (err) {
            return;
          }
          this.setState({ clientToken: res.token, clientInstance });
        }
      );
    });
  }

  componentWillUnmount() {
    this.destroyHostedFields();
    this.destroyPaypal();
  }

  destroyHostedFields() {
    return new Promise(resolve => {
      if (this.hostedFieldsInstance) {
        this.hostedFieldsInstance.teardown(() => {
          this.hostedFieldsInstance = null;
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  destroyPaypal() {
    return new Promise(resolve => {
      if (this.paypalInstance) {
        this.paypalInstance.teardown(() => {
          this.paypalInstance = null;
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  handleShow() {
    this.setState({ show: true });
    this.createCheckout();
  }

  handleHide() {
    this.setState({ show: false });
  }

  handleSave() {
    this.hostedFieldsInstance
      .tokenize()
      .then(res => {
        this.props.save({ nonce: res.nonce, type: this.state.type });
        this.setState({ show: false });
      })
      .catch(err => {
        this.props.setError('Invalid payment information');
      });
  }

  async createCheckout() {
    await this.destroyPaypal();
    await this.destroyHostedFields();
    if (this.state.type === 'card') {
      this.createHostedFields();
    } else {
      this.createPaypalCheckout();
    }
  }

  createPaypalCheckout() {
    BraintreePaypal.create(
      {
        client: this.state.clientInstance
      },
      (err, paypalCheckoutInstance) => {
        if (err) {
          console.error('Error creating PayPal Checkout:', err);
          return;
        }

        this.paypalInstance = paypalCheckoutInstance;

        const container = document.getElementById('paypal-button');
        if (container) container.innerHTML = '';

        window.paypal.Button.render(
          {
            env: process.env.RUN_ENV === 'production' ? 'production' : 'sandbox',
            style: {
              color: 'blue',
              shape: 'rect',
              size: 'small',
              height: 42,
              label: 'paypal',
              tagline: false
            },
            payment: () => {
              return this.paypalInstance.createPayment({
                flow: 'vault',
                currency: 'USD'
              });
            },
            onAuthorize: data => {
              return this.paypalInstance.tokenizePayment(data, (err, payload) => {
                if (err) {
                  this.props.setError('Invalid payment information');
                  return false;
                }

                this.props.save({
                  nonce: payload.nonce,
                  type: this.state.type
                });
                this.setState({ show: false });
              });
            },
            onCancel: data => {
              console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
            },
            onError: err => {
              console.error('Paypal Checkout error', err);
              this.props.setError(err);
            }
          },
          '#paypal-button'
        ).then(() => {});
      }
    );
  }

  createHostedFields() {
    if (this.hostedFieldsInstance) return;
    BraintreeHostedFields.create(
      {
        client: this.state.clientInstance,
        styles: {
          ':focus': {
            color: 'black'
          },
          '.valid': {
            color: '#8bdda8'
          }
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '',
            rejectUnsupportedCards: true
          },
          cvv: {
            selector: '#cvv',
            placeholder: '',
            type: 'password'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YYYY'
          }
        }
      },
      (err, hostedFieldsInstance) => {
        if (err) console.error(err);
        else {
          this.hostedFieldsInstance = hostedFieldsInstance;
        }
      }
    );
  }

  render() {
    return (
      <div className='white_box_details'>
        <h3>Payment method</h3>
        <p>We will use this information for your next billing</p>
      
        {this.props.data.card ? (
          <div className='card_details'>
            <div className={`card_type ${this.props.data.card.card_type}`}>
              **** **** **** {this.props.data.card.last4}
            </div>
            <Button variant='outline-primary' size="md" onClick={this.handleShow}>
              Update payment method
            </Button>
          </div>
        ) : this.props.data.paypal ? (
          <div className='card_details'>
            <div className='card_type paypal'>&nbsp;</div>
            <Button variant='outline-primary' size="md" onClick={this.handleShow}>
              Update payment method
            </Button>
          </div>
        ) : (
          <div className='card_details'>
            <Button variant='outline-primary' size="md" onClick={this.handleShow}>
              Add payment method
            </Button>
          </div>
        )}

        <Modal
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          className='modal_form_payment'
        >
          <Modal.Header>
            <Modal.Title>{this.props.data.card ? 'Update' : 'Add'} card details</Modal.Title>
            <Button variant="close" onClick={() => this.setState({ show: false })}>
              <img src={Close} alt="close" />
            </Button>
          </Modal.Header>
          <Modal.Body>
            {!this.state.clientToken ? (
              <div>Loading</div>
            ) : (
              <form id="cardForm" className='form_payment'>
                <Row>
                  <Col sm={12}>
                    <RadioButton
                      id="card_payment"
                      name="paymenttype"
                      label={
                        <div className='details'>
                          <label>Card</label>
                          <div className='card visa'></div>
                          <div className='card mastercard'></div>
                          <div className='card maestro'></div>
                          <div className='card discover'></div>
                          <div className='card american_express'></div>
                        </div>
                      }
                      value="card"
                      checked={this.state.type == 'card'}
                      onChange={e => this.setState({ type: e.value }, () => this.createCheckout())}
                    />
                  </Col>

                  {this.state.type === 'card' && (
                    <div className='card_details_container'>
                      <Col sm={12}>
                        <label>Card Number</label>
                        <div id="card-number" className='form-control'></div>
                      </Col>
                      <Col sm={6}>
                        <label>Expiration Date</label>
                        <div id="expiration-date" className='form-control'></div>
                      </Col>
                      <Col sm={6}>
                        <label>CVV</label>
                        <div id="cvv" className='form-control'></div>
                      </Col>
                    </div>
                  )}

                  <Col sm={12} className='paypal_container'>
                    <RadioButton
                      id="paypal_payment"
                      name="paymenttype"
                      label={
                        <div className='details'>
                          <label>Paypal</label>
                          <div className='card paypal'></div>
                        </div>
                      }
                      value="paypal"
                      checked={this.state.type == 'paypal'}
                      onChange={e => this.setState({ type: e.value }, () => this.createCheckout())}
                    />
                  </Col>
                </Row>
              </form>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.type === 'card' && (
              <Button  onClick={this.handleSave}>
                <img src={saveIcon} alt='' /> Save
              </Button>
            )}
            {this.state.type === 'paypal' && (
              <div className='btn btn-primary' id="paypal-button"></div>
            )}
            <Button variant="secondary"  onClick={() => this.setState({ show: false })}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(error(err)),
    save: data => dispatch(savePaymentInfo(data))
  };
};

export default connect(undefined, mapDispatchToProps)(PaymentMethod);
